namespace nscs.gameplay {

    export class Gameplay {

        public static isPamLocked:boolean = true;

        public static languages = ["EN","NL","ES","SK","JA","DE"];
        public static currentLanguage:string = "EN";

        public static setText(textField:Phaser.GameObjects.Text, stringsType:string, updateTextFieldPosition:boolean = true):void {
            let str:string = this.strings[stringsType][Gameplay.languages.indexOf(Gameplay.currentLanguage)];
            if (updateTextFieldPosition) {
                nscs.util.Functions.updateTextFieldPosition(textField, str);
            } else {
                textField.setText(str);
            }
        }

        public static getText(stringsType:string):string {
            let str:string = this.strings[stringsType][Gameplay.languages.indexOf(Gameplay.currentLanguage)];

            let character:string = nscs.scene.MainScene.instance.gameplay.character;

            let substr:string = '--player--';
            while (str.indexOf(substr) >= 0) {
                str = str.replace(substr,
                    nscs.util.Functions.capitalise(nscs.scene.MainScene.instance.gameplay ?
                        character : Gameplay.characters[0]));
            }

            substr = '--princess--';
            let replaceWith:string = character != "pam" ? "me" : "us";
            while (str.indexOf(substr) >= 0) {
                str = str.replace(substr, replaceWith);
            }

            substr = '--me--';
            while (str.indexOf(substr) >= 0) {
                str = str.replace(substr, character);
            }

            return str;
        }

        public static strings:object = {
            NewGameBtn :["New Game","Nieuwe game","Juego nuevo","Nová hra","新しいゲームへ","Neues Spiel"],
            StartKidFriendlyGameBtn :["Start Kid-Friendly Game","Start dit kindvriendelijke spel","Iniciar juego apropiado para niños","Hra začiatočného stupňa vhodná pre deti","子ども用ゲームをスタート","Kinderfreundliches Spiel starten"],
            NextBtn :["Next","Volgende","Siguiente","Ďalší","次"," Zunächst "],
            EnterCodeBtn :["Enter Code","Entercode","Introduce código","Zadaj kód","コード入力","Code eingeben"],
            EnterCodePrompt :["Enter code to play as Pamela Anderson:","Klik op de entercode en speel als Pamela:","Introduce el código para jugar como Pamela Anderson:","Zadaj kód, aby si mohol hrať ako Pamela Andersonová:","パメラ・アンダーソンとしてプレーするためにコードを入力","Gib den Code ein, um als Pamela zu spielen:"],
            OKBtn :["OK","OK","Aceptar","OK","OK","OK"],
            CancelBtn :["Cancel","Annuleer","Cancelar","Zruš","キャンセル","Löschen "],
            HighScoresBtn :["High Scores","Hoge scores","Puntuación alta","Vysoké skóre","ハイスコア","High Score"],
            Instruct1 :["Colonel Sanders and his minions have kidnapped Pamela Anderson for revealing to the world that KFC's secret recipe is cruelty to chickens! Help the Super Chick Sisters save Pam before it's too late!"],
            StartGameBtn :["Start Game","Start game","Iniciar juego","Spustiť hru","ゲーム開始","Spiel starten"],
            Instruct2 :["Use the arrows to move. Use the \"up\" arrow to jump, climb, and break blocks. Click ESC to pause the game.Defeat enemies by jumping on their heads."],
            ChooseChar :["Choose Your Character!","Kies je personage!","¡Elige su personaje!","Zvoľ si svoju postavičku!","キャラクターを選んでください","Wähle Deine Figur!"],
            Nugget :["Nugget","Goudhaantje","Nugget","Nugget","ナゲット","Nugget"],
            Chickette :["Chickette","Kippie","Chickette","Chickette","チッケット","Chickette"],
            Pam :["Pam","Pam","Pam","Pam","パメラ・アンダーソン","Pam"],
            PamLong :["Pamela Anderson","Pamela Anderson","Pamela Anderson","Pamela Andersonová","パメラ・アンダーソン","Pamela Anderson"],
            Locked :["Locked","Gesloten","Cerrado","Zamknutý","ロックされています","Gesperrt"],
            World :["World","Wereld","Mundo","Svet","ワールド","Welt"],
            Time :["Time","Tijd","Tiempo","Čas","時間","Zeit"],
            Paused :["Game Paused","Spel afgebroken","Juego en pausa","Hra je prerušená","ゲーム一時停止","Pause"],
            QuitBtn :["Quit","Stoppen","Abandonar","Skončiť","終了","Ende"],
            ResumeBtn :["Resume","Terug","Continuar","Obnoviť","再開","Weiterspielen"],
            TimeOver :["Time Over!","Tijd verlopen!","¡Tiempo muerto!","Koniec vymedzeného času!","時間切れです！","Zeit zuende!"],
            activist1 :["Hi, --player--! Did you know that KFC chickens have their sensitive beaks cut off?! How painful! Many birds are so stressed from being \"debeaked\" that they cannot eat. Please, hurry!"],
            activist2 :["Thank goodness you\'re here, --player--! KFC is scalding chickens to death! Many birds are still awake when their feathers are scalded off in \"defeathering tanks.\" Can you imagine THAT?! Yuck!"],
            activist3 :["--player--! We\'ve seen so many crippled chickens with broken wings and legs. And these overgrown birds are still just babies when they are killed! You can\'t let the Colonel get away with this!"],
            activist4 :["Hurry, --player--! We just found out that the chickens are being fed drugs that make them grow so large that many of them won\'t be able to move! You\'ve got to help them!"],
            activist5 :["You\'re just in time, --player--! You have to stop KFC from making more bloody buckets!"],
            activist6 :["Things are getting worse around here, --player--. The Colonel wants to sell more and more chickens, and he doesn\'t care at all about how unhappy they are. You\'re the only one who can stop him!"],
            activist7 :["Keep up the great work, --player--! Once everyone knows exactly what the Colonel is doing to these chickens to make his buckets, he\'ll have to stop it!"],
            activist8 :["It\'s so horrible what KFC does to these chickens! They have their sensitive beaks cut off and their legs broken, and they\'re often scalded to death!"],
            activist9 :["--player--! KFC and the Colonel don\'t even use painkillers when they cut the chickens\' throats. There must be something we can do to stop them!"],
            activist10 :["These chickens are crammed into spaces so small, they barely have room to move around. Can you believe it?!"],
            activist11 :["Don\'t give up now, --player--. We\'ve got the Colonel on the run!"],
            activist12 :["--player--! Some of these chickens have horrible diseases, and the Colonel won\'t do anything to help them. Please, hurry!"],
            activist13 :["Thank you so much for helping the chickens, --player--! The KFC workers have to catch so many that they just grab them and throw them onto trucks, which often breaks their wings and legs!"],
            activist14 :["We\'re so glad you\'re helping these chickens, --player--! KFC should never be allowed to get away with what it\'s doing."],
            activist15 :["I\'m sorry, but --princess-- in another building."],
            activist16 :["I\'m sorry, but --princess-- in another building."],
            activist17 :["I\'m sorry, but --princess-- in another building."],
            activist18 :["I\'m sorry, but --princess-- in another building."],
            activist19 :["Thanks for saving me! Now we have to let the world know that wicked Colonel Sanders slices chickens\' sensitive beaks off when they\'re only 10 days old and throws them alive into near-boiling water to remove their feathers..."],
            activist20 :["With your help, we can let the Colonel know that nobody\'s going to eat at KFC until this cruelty stops."],
            GameOver :["Game Over!","Game over!","¡Juego terminado!","Koniec hry!","ゲーム終了！","Game over!"],
            GameOverText :["Learn more about McDonald\'s cruelty to prepare for your next game.","Leer meer over de wreedheid van McDonald\'s om je op de volgende game voor te bereiden.","Aprende más sobre la crueldad de McDonald\'s y te prepara para tu próximo juego.","Dozveď sa viac o McDonaldovej krutosti a priprav sa na novú hru.","次のゲームのために、マクドナルドによる虐待について、もっと見てください！ ","Lerne mehr über die Grausamkeit bei McDonald’s USA."],
            PlayAgainBtn :["Play Again","Opnieuw spelen","Jugar otra vez","Znovu hraj","もう１度ゲームをする ","Nochmal spielen"],
            HighScoresTitle :["High Scores!","Hoge scores","Puntuación alta","Vysoké skóre","ハイスコア","High Scores"],
            HighScoresConnecting :["Connecting to high score server...","Ga naar de hoge score server ...","Conectando al servidor de puntuación alta…","Pripájanie sa na server vysokého skóre…","ハイスコア・サーバーに接続中・・・","Verbindung zum High Score Server wird hergestellt"],
            HighScoresUnreachable :["The high score server cannot be reached! Please check your Internet connection and try again...","De server is niet te bereiken. Controleer je internetverbinding en probeer het opnieuw.","¡El servidor de puntuación alta no puede ser encontrado! Por favor checa tu conexión del Internet e inténtalo otra vez…","Server vysokého skóre sa nedá dosiahnuť! Skontroluj internetové spojenie a znovu sa pokús…","ハイスコア・サーバーに接続できません！インターネット接続を確認して、もう１度試してください・・・","Der High Score Server kann nicht verbunden werden. Bitte kontrolliere Deine Internetverbindung und versuche es noch einmal..."],
            RetryBtn :["Retry","Herstart","Reintentar","Opakovať","再試行","Wiederholen"],
            AllTimeBtn :["All Time","Top Score","Sin precedentes","Rekordný","過去最高","Alle"],
            RecentBtn :["Recent","Recent","Reciente","Aktuálny","最近","Letzte"],
            RestartBtn :["Restart","Herstart","Reanudar","Reštartuj","リスタート","Neustart"],
            HighScoreTitle :["High Score!","Hoge score!","¡Puntaje alto!","Vysoké skóre!","ハイスコア！","High Score!"],
            NamePrompt :["Name:","Naam:","Nombre:","Meno:","名前： ","Name"],
            PostBtn :["Post!","Verzend!","¡Fijar!","Zverejni!","掲示！","Eingeben!"],
            allTimeNotice :["Yours is an all-time high score! Post your name to the scoreboard!","Jij hebt de allerhoogste score! Plaats je naam op het scorebord!","¡Tienes un puntaje alto sin precedentes! ¡Fija tu nombre al marcador!","To tvoje sa nachádza v kategórii rekordne vysokého skóre! Zverejni svoje meno na tabuli výsledkov!","過去最高のハイスコアです！スコアボードに名前を掲示してください！ ","Du hast einen All-Time-High Score geschafft. Schreib Deinen Namen an die Ehrenwand!"],
            recentNotice :["Yours is a recent high score! Post your name to the scoreboard!","Jouw score was een van de hoogste! (Plaats je naam op het scorebord!","¡Tienes un puntaje alto reciente! ¡Fija tu nombre al marcador!","To tvoje sa nachádza v kategórii aktuálne vysokého skóre! Zverejni svoje meno na tabuli výsledkov!","最近のハイスコアです！スコアボードに名前を掲示してください","Du hast einen neuen High Score geschafft. Schreib Deinen Namen an die Ehrenwand!"],

            cutscene0_1 :["Pamela Anderson: I am here today to tell you the terrible secrets that KFC has been trying to keep from the public about what it does to chickens."],
            cutscene0_1B :["Pamela Anderson: Here goes..."],
            cutscene0_2 :["What the ...?!"],
            cutscene0_3 :["Mmmmmph! Mmmmmph!"],
            cutscene0_4 :["Toad: Hey, guys! Someone\'s been kidnapped! Stop playing Wii and get down here!"],
            cutscene0_5 :["Mario: We played too long. I can\'t feel my arm anymore!"],
            cutscene0_5B :["Mario: I think we have ... Wiitis."],
            cutscene0_6 :["Mario: We need to see a doctor! It\'s not as if there\'s another pair of super-powered siblings out there who can help save the day..."],
            cutscene0_7 :["Pam\'s in trouble! There\'s no time to lose!"],

            cutscene1_1 :["There\'s still work to be done ..."],
            cutscene1_2 :["Mario: You have to hurry, doc! There\'s simply no one else out there who can help save this kidnapped princess."],

            cutscene2_3 :["Activist: You!\rMario: Uh-oh ..."],

            "": ["                                                                           "], //mock

            cutscene3_1 :["Our work here is done. Let\'s move on and rescue Pam before it\'s too late!"],
            cutscene3_2 :["Mario: Excuse me, but have you seen this woman? She\'s been kidnapped, and as usual, I\'m the only one who can save the day."],
            cutscene3_3 :["Mario: Princess?! What are you doing here?"],
            cutscene3_3B :["Princess Peach: Don\'t you worry about that. Hey, whose picture are you holding?"],
            cutscene3_4 :["Mario: Um ... she\'s ... um ..."],

            cutscene4_1 :["Mario: Yoshi! My faithful steed! Saddle up - we have to hurry and save the day."],
            cutscene4_1B :["Yoshi: Why don\'t you saddle yourself up? What makes you think you can ride me around anyway?"],
            cutscene4_2 :["Yoshi: My new friends have taught me that I don\'t have to do anything I don\'t want to do."],

            cutscene4_3 :["Chickette: We must hurry before she ends up in an unhappy meal!","Kippie: We moeten opschieten voordat ze in een unhappy meal terecht komt!","Chickette: ¡Tenemos que apresurarnos antes de que se transformara en una cajita infeliz!","Chickette: Musíme sa ponáhľať prv než sa ocitne v unhappy meal!","チッケット：パメラ姫がアンハッピー・ミールになっちゃう前に助けなくちゃ！","Chickette: Wir müssen uns beeilen, ansonsten endet sie in einem Unhappy Meal!"],
            cutscene5_1 :["Mario: Those other superhero siblings have rescued the Princess again …","Mario: Die andere superheldhaftige broertjes en zusjes hebben de prinses weer gered  …","Mario: Esos otros hermanos superhéroes han rescatado a la princesa otra vez…","Mario: Tí ostatní súrodenci-superhrdinovia znovu zachránili princeznu…","マリオ：また、あっちのスーパーヒーローきょうだいに先を越された","Mario: Diese anderen beiden Superhelden-Zwillinge haben mal wieder die Prinzessin gerettet."],
            cutscene5_1B :["Bowser: Fungah! Foiled again!","Bowser: Fungah! Weer verslagen!","Bowser: ¡Funga! ¡Frustrado otra vez!","Prehliadač: Fungah! Znovu je to zneškodnené!","バウザー：フンガー！まただめだったか！","Bowser: Verdammt! Was für \'ne Pleite!"],
            cutscene5_2 :["Phone: Ring, ring, ring","Telefoon: Tring, tring, tring","Teléfono: Ring, ring, ring","Telefón: zvonenie, zvonenie, zvonenie","電話：リーン、リーン、リーン","Phone: Ring, Ring, Ring"],
            cutscene5_3 :["Mario: Another offer just came in … a surefire hit: \'New Mario Teaches Typing\'.","Mario: Er kwam net een andere game-aanbieding binnen … een gegarandeerde hit: \'New Mario Teaches Typing\'.","Mario: Otra oferta acaba de llegar… un éxito seguro: \'Nuevo Mario enseña teclear\'.","Mario: Ďalšia ponuka prišla…stopercentný hit: Nový Mario učí písanie na stroji.","マリオ：また新しい話が来た。「新・タイプの先生マリオ」だって。ヒット確実だ。 ","Mario: Gerade kam ein neues Angebot herein, das wird definitiv ein Bestseller: \'Mario bringt euch das Tippen bei\'."],
            cutscene5_4 :["Bowser: What people really want is \'Luigi Paint\'!","Bowser: Wat de mensen echt willen is de game \'Luigi Paint\'!","Bowser: ¡Lo que le gente realmente quiere es \'Luigi dibuja\'!","Prehliadač: Čo ľudia naozaj chcú, to je Luigiho Farba!","バウザー：ほんとにヒットするのは「ルイジ・ペイント」だ！","Bowser: Was die Kids wirklich wollen ist doch \'Luigi Paint\'!"],
            cutscene5_5 :["Luigi: Yeah, nobody wants more Mario shovelware!","Luigi: Ja, niemand wil meer ouwe meuk van Mario!","Luigi: ¡De acuerdo, nadie quiere más \'shovelware\' de Mario!","Luigi: Mhm, nikto už viac nechce Mariove lopaty!","ルイジ：そうだ、もうみんなマリオのシャベルウェアには飽き飽きしているよ","Luigi: Ja genau, keiner will mehr diese Mario-Ramschware"],
            cutscene5_6 :["You have rescued me again and saved millions of chickens from the worst abuses at the hands of McDonald\'s.","Je hebt me weer bevrijd en miljoenen kippen gered van de ergste mishandelingen uit de handen van McDonald\'s.","Me han salvado otra vez y salvado millones de pollos de los abusos horribles en las manos de McDonald\'s. ","Ty si znovu zachránil nielen mňa, ale aj milióny kurčiat, a to pred najhorším týraním McDonaldovými rukami.","また私を助けてくれてありがとう。そしてマクドナルドのひどい虐待から、何百万羽ものニワトリを助けてくれてありがとう","Ihr habt mich einmal mehr gerettet und Millionen von Hühnern vor den schlimmsten Misshandlungen durch McDonald’s USA bewahrt."],
            cutscene5_7 :["To play again as me, enter this secret code: PamvsMcCruelty.","Om weer te kunnen spelen verander de code in: PamVsMcCruelty.","Para jugar otra vez como yo, entra este código secreto: PamVsMcCruelty.","Ak chceš hrať v mojom mene, vlož tento tajný kód: PamVsMcCruelty.","もう１度「私」としてプレーするには、次のシークレット・コードを入力してください：PamVsMcCruelty. ","Um nochmal zu spielen, gib diesen Geheim-Code ein: PamvsMcCruelty."],
            vid1 :["You\'ve earned a bonus video!","Je hebt een bonusvideo verdiend!","¡Has ganado un vídeo adicional!","Získal si prémiové video.","ボーナス･ビデオの時間です！","Du hast Dir ein Bonus-Video verdient!"],
            vid2 :["Game Will Continue In …","Het spel gaat verder ,,,","Juego continuará en…","Hra bude pokračovať o…","ゲーム継続まで・・・","Spiel wird fortgesetzt in …"],
            vid3 : ["Continue Game","Speel  door ","Continuar juego","Pokračuj v hre","ゲーム継続","Spiel fortsetzen"],
        };

        public static characters:string[] = ['nugget', 'chickette', 'pam'];
        character:string = Gameplay.characters[0];


        worlds = [
            ["1","_LEVEL1DATA",400,146,320,         NaN],
            ["2","_LEVEL2DATA",700,146,130,         [
                {p1:{x:700,y:1450},p2:{x:860,y:1450},p3:{x:860,y:1500},p4:{x:700,y:1500}},
                {p1:{x:10,y:1250},p2:{x:580,y:1250},p3:{x:580,y:1500},p4:{x:10,y:1500}},
                {p1:{x:1400,y:960},p2:{x:1600,y:960},p3:{x:1600,y:1100},p4:{x:1400,y:1100}},
                ]
            ],
            ["2.1","_LEVEL2_1DATA",150,250,560,     [
                {p1:{x:180,y:650},p2:{x:900,y:650},p3:{x:900,y:750},p4:{x:180,y:750}}
            ]],
            ["2.2","_LEVEL2_2DATA",200,1998,1470,   NaN],
            ["3","_LEVEL3DATA",800,110,32,          [
                {p1:{x:250,y:1175},p2:{x:450,y:1175},p3:{x:450,y:1300},p4:{x:250,y:1300}},
                {p1:{x:1200,y:640},p2:{x:1450,y:640},p3:{x:1450,y:750},p4:{x:1200,y:750}},
                {p1:{x:1740,y:400},p2:{x:1940,y:400},p3:{x:1940,y:750},p4:{x:1740,y:750}},
                {p1:{x:50,y:1450},p2:{x:2800,y:1450},p3:{x:2800,y:1600},p4:{x:50,y:1600}},
                {p1:{x:350,y:850},p2:{x:700,y:850},p3:{x:700,y:950},p4:{x:350,y:950}}
                ]
            ],
            ["3.1","_LEVEL3_1DATA",100,286,480,     NaN],
            ["3.2","_LEVEL3_2DATA",100,320,320,     NaN],
            ["4","_LEVEL4DATA",900,170,1420,        NaN],
            ["4.1","_LEVEL4_1DATA",400,242,1450,    NaN],
            ["5","_LEVEL5DATA",900,120,1420,        NaN],
            ["5.1","_LEVEL5_1DATA",150,394,1472,    NaN],
        ];
        thisWorldId:number = 0;

        lives:number = 3;

        // player physics:
        charSize:string = 'small';
        ammo:number = 0; // int representing appropriate bullet MC frame (0: no ammo)
        seaKitten:boolean = false;
        xSpeed0:number = 180; // 1 - 10
        xSpeed:number = this.xSpeed0; // 1 - 10
        movingPlatformSpeed:number = this.xSpeed0 * 0.7;
        ladderSpeed0:number = 125; // 1 - 10
        jumpHeight0:number = 620; // 1 - 10
        jumpHeight:number = this.jumpHeight0;
        public static readonly gravity0:number = 1285; // 1 - 10
        gravity:number = Gameplay.gravity0; // 1 - 10
        gravityDir:number = 1; // 1 is upright -1 is upside down

        // init
        inWater:boolean = false;
        waterLevel:number = NaN;
        waterRects:object[] = null;
        ladderSpeed = this.ladderSpeed0;

        timer0:number;
        timer:number;
        newX:number;
        newY:number;

        constructor() {
        }

        levelData:object;

        // world dimensions
        readonly tileWidth:number = 32;
        readonly tileHeight:number = 32;
        readonly worldTilesX:number = 90;
        readonly worldTilesY:number = 47;

        grid:number[][];
        solid_array:string[];
        ladder_array:string[];
        collect_array:string[];
        spriteList:string[];

        levelComplete:boolean = false;

        public gameScreen:nscs.screen.GameScreen = null;

        public worldWidth:number;
        public worldHeight:number;

        private gameScreensInCache:nscs.screen.GameScreen[] = [];

        public isGravityFlipped():boolean {
            return this.gravityDir < 0;
        }
        public calculateGravity():number {
            return this.gravity * this.gravityDir;
        }

        public getFanWaterCoefficient():number {
            return this.inWater ? 1 : 1/1.5;
        }

        public loadWorld(worldId:number|string, transitionFlag:boolean = true, destroyPreviousWorlds:boolean = true, takeFromCache:boolean = false) {
            this.grid = null;
            this.levelComplete = false;

            this.worldWidth = this.tileWidth * this.worldTilesX;
            this.worldHeight = this.tileHeight * this.worldTilesY;
            nscs.scene.MainScene.instance.physics.world.bounds.width = this.worldWidth;
            nscs.scene.MainScene.instance.physics.world.bounds.height = this.worldHeight;

            if (typeof worldId === "string") {
                for (let i:number = 0; i < this.worlds.length; i++) {
                    if (this.worlds[i][0] == worldId) {
                        worldId = i;
                        break;
                    }
                }
            }
            this.thisWorldId = worldId as number;

            // gather world information
            let world = this.worlds[this.thisWorldId];
            this.newX = Number(world[3]);
            this.newY = Number(world[4]);

            let waterRects:object[] = [];
            if (typeof world[5] == "number") {
                this.waterLevel = Number(world[5]);
            } else {
                for (let elemet of world[5]) {
                    if (typeof elemet == "number") {
                        this.waterLevel = Number(elemet);
                    } else {
                        waterRects.push(elemet as any);
                    }
                }
            }
            if (waterRects.length > 0) this.waterRects = waterRects; else this.waterRects = null;

            this.timer0 = this.timer = Number(world[2]);

            this.loadLevel(String(world[1]));

            let prevGameScreen:nscs.screen.GameScreen = this.gameScreen;
            this.gameScreen = null;
            let takenFromCache:boolean = false;
            if (takeFromCache) {
                for (let i:number = this.gameScreensInCache.length - 1; i >= 0; i--) {
                    if (this.gameScreensInCache[i].worldIdName == world[0]) {
                        this.gameScreen = this.gameScreensInCache[i];
                        this.gameScreensInCache.splice(i, 1);
                        takenFromCache = true;
                        break;
                    }
                }
            }

            if (destroyPreviousWorlds) {
                this.destroyPreviousWorlds();
                this.gravityDir = 1;
            } else {
                if (prevGameScreen) {
                    let notExistSameNamedGameScreenAlready:boolean = true;
                    for (let i:number = this.gameScreensInCache.length - 1; i >= 0; i--) {
                        if (this.gameScreensInCache[i].worldIdName == prevGameScreen.worldIdName) {
                            notExistSameNamedGameScreenAlready = false;
                            break;
                        }
                    }
                    if (notExistSameNamedGameScreenAlready) {
                        this.gameScreensInCache.push(prevGameScreen);
                    }
                }
            }

            if (!takenFromCache) {
                this.gameScreen = new nscs.screen.GameScreen(nscs.scene.MainScene.instance, world[0] as string);
                this.loadSprites();
                this.gameScreen.fetchRecoveryPoints();
            }
            nscs.scene.MainScene.instance.switchScreen(this.gameScreen, transitionFlag, destroyPreviousWorlds);

            nscs.util.Functions.updateTextFieldPosition(this.gameScreen.inGameUI.world_txt, String((world[0] as string).split(".")[0]));
            nscs.util.Functions.updateTextFieldPosition(this.gameScreen.inGameUI.timer_txt, String(this.timer));
            this.gameScreen.inGameUI.setCharacterName(nscs.util.Functions.capitalise(this.character), this.lives);
            this.gameScreen.inGameUI.setScore(this.score);

            this.startTimer();
        }

        public destroyPreviousWorlds():void {
            for (let i:number = this.gameScreensInCache.length - 1; i >= 0; i--) {
                this.gameScreensInCache[i].destroy(true);
                this.gameScreensInCache.splice(i, 1);
            }
        }

        //TIMER
        private timerEvent: Phaser.Time.TimerEvent;
        public startTimer():void {
            this.destroyTimer();

            this.timerEvent = nscs.scene.MainScene.instance.time.addEvent({ delay: 1000, repeat: this.timer0 });
            this.timerEvent.callback = ()=>{
                this.timer = this.timerEvent.repeatCount;
                nscs.util.Functions.updateTextFieldPosition(this.gameScreen.inGameUI.timer_txt, String(this.timer));

                if (this.timer == 0) {
                    this.gameScreen.onTimeout();
                }
            };
        }

        public pause():void {
            this.timerEvent.paused = true;
        }

        public resume():void {
            this.timerEvent.paused = false;
        }

        public destroyTimer():void {
            if (!this.timerEvent) return;
            this.timerEvent.paused = true;
            this.timerEvent.destroy();
        }

        public destroy():void {
            this.destroyPreviousWorlds();
            this.destroyTimer();
        }

        public loadLevel(worldFile:string):void {
            let data:object = nscs.scene.MainScene.instance.cache.json.get('data');
            let levelDataRaw:string = data[worldFile];

            this.levelData = new Object();
            let levelDataVars = levelDataRaw.split('&');
            for(let ldv=0;ldv<levelDataVars.length;ldv++) {
                let dataBits = levelDataVars[ldv].split('=');
                let varName = dataBits[0];
                let varValue = dataBits[1];
                this.levelData[varName] = varValue;
            }

            var dats = this.levelData["ldat"].split(",");
            var cnt = 0;
            this.grid = new Array(this.worldTilesY);
            for (var i = 0; i<this.worldTilesY; i++) {
                this.grid[i] = new Array(this.worldTilesX);
                for (var j=0; j<this.worldTilesX; j++) {
                    this.grid[i][j] = Number(dats[cnt++]);
                }
            }

            this.solid_array = this.levelData['sol'].split(",");
            this.ladder_array = this.levelData['lad'].split(",");
            this.spriteList = this.levelData['sprites'].split(',');

            this.updateWaterPhysics();
        }

        public loadSprites():void {
            let spriteCount:number = 0;
            for (let sp=0; sp<this.spriteList.length; sp++) {
                spriteCount++;

                let spriteInfo = this.spriteList[sp].split('|');
                /*
                spriteInfo[0] = sprite id
                spriteInfo[1] = x
                spriteInfo[2] = y
                spriteInfo[3] = libId
                spriteInfo[4] = options
                */
                let sprite_mc = nscs.scene.MainScene.instance.factory.createSprite(spriteInfo);
                sprite_mc["spriteNumber"] = spriteCount;

                let attachedSprites = null;
                if (sprite_mc["-attachedSprite-"]) {
                    attachedSprites = Array.isArray(sprite_mc["-attachedSprite-"]) ? sprite_mc["-attachedSprite-"] : [sprite_mc["-attachedSprite-"]];
                    for (let a of attachedSprites) {
                        a.setPosition(sprite_mc.x, sprite_mc.y);
                    }
                    if (sprite_mc["-attachedSprite-layer-"] == "under") {
                        for (let a of attachedSprites) {
                            this.gameScreen.addSprite(a);
                        }
                    }
                }

                this.gameScreen.addSprite(sprite_mc);

                if (attachedSprites && sprite_mc["-attachedSprite-layer-"] != "under") {
                    for (let a of attachedSprites) {
                        this.gameScreen.addSprite(a);
                    }
                }
            }

            this.gameScreen.onSpritesAdded();
        }

        public addLife():void {
            this.lives++;
            this.gameScreen.showTextPopUp('1UP');
            this.gameScreen.inGameUI.setCharacterName(nscs.util.Functions.capitalise(this.character), this.lives);
        }

        public minusLife():void {
            this.lives--;
            this.gameScreen.inGameUI.setCharacterName(nscs.util.Functions.capitalise(this.character), this.lives);

            this.setSeaKitten(false);
        }

        /////////////////// SCORING ////////////////////
        score:number = 0;
        public addToScore(scoreToAdd:number) {
            this.score += scoreToAdd;
            this.gameScreen.inGameUI.setScore(this.score);
        }
        scoreUps:number = 10;
        public scoreUp(scoreBit) {
            this.gameScreen.scoreUp(scoreBit);

            // play scoreUp animation:
            this.addToScore(scoreBit);
            this.scoreUps++;
        }

        milestone:number = 0;
        chicks:number = 0;
        public addChick():void {
            this.chicks++;
            this.gameScreen.inGameUI.setChicks(this.chicks);
            if (Math.floor(this.chicks/100) > this.milestone) {
                this.milestone = Math.floor(this.chicks/100);
                this.addLife();
            }
        }

        public getNextWorldNumber():number {
            let thisWorldId:number|string = this.thisWorldId;
            if (typeof thisWorldId == "number") {
                thisWorldId = this.worlds[this.thisWorldId][0] as string;
            }
            let thisWorldsNumber:number = Math.floor(parseFloat(thisWorldId));
            return thisWorldsNumber + 1;
        }

        public loadNextWorld():void {

        }

        public setSeaKitten(active:boolean):void {
            this.seaKitten = active;
        }

        public updateWaterPhysics() {
            if (this.inWater) {
                this.gravity = Gameplay.gravity0 * 0.19;
                if (this.seaKitten) {
                    this.xSpeed = this.xSpeed0 * 0.65;
                    this.jumpHeight = this.jumpHeight0 * 0.4;
                } else {
                    this.xSpeed = this.xSpeed0 * 0.7;
                    this.jumpHeight = this.jumpHeight0 * 0.47;
                }
            } else {
                // revert
                this.gravity = Gameplay.gravity0;
                this.xSpeed = this.xSpeed0;
                this.jumpHeight = this.jumpHeight0;
            }
        }

        public calculateTotalScore():void {
            this.score += this.timer * 100;
            if (this.thisWorldId == 5) {
                this.score += this.lives * 1500;
            }
        }
    }
}
